/**
 * @fileoverview Redux store — GlobalAnka projesinin merkezi veri yönetim noktası.
 * Redux-persist ile dil (language) ve kullanıcı arayüzü (ui) tercihleri yerel hafızada saklanır.
 *
 */

import { configureStore } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer, 
  FLUSH, 
  REHYDRATE, 
  PAUSE, 
  PERSIST, 
  PURGE, 
  REGISTER 
} from 'redux-persist';
// Vite ve ESM uyumluluğu için temel storage nesnesi
import storage_base from 'redux-persist/lib/storage'; 
import rootReducer from './rootReducer';

/**
 * Vite 5 / ESM ortamında storage.getItem hatasını önlemek için 
 * default export kontrolü yapıyoruz.
 */
const storage = storage_base.default || storage_base;

/** * Redux-persist yapılandırması
 * @type {import('redux-persist').PersistConfig} 
 */
const persistConfig = {
  key: 'globalanka-root',
  version: 1,
  storage, 
  whitelist: ['language', 'ui'],   // Sadece dil ve mobil menü durumu kalıcı
  blacklist: ['portfolio', 'leadForm'], // Form verileri ve portfolyo her seferinde sıfırlanır
};

// Kalıcı hale getirilmiş (persisted) ana reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

/**
 * Redux Store Konfigürasyonu
 */
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Redux-persist aksiyonlarını kontrol dışı bırakarak hata almayı önler
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  // Sadece geliştirme modunda DevTools aktif
  devTools: import.meta.env.DEV,
});

// Veri kalıcılığını (persistence) başlatan nesne
export const persistor = persistStore(store);

/**
 * JSDoc Helper Tipleri
 * @typedef {ReturnType<typeof store.getState>} RootState
 * @typedef {typeof store.dispatch} AppDispatch
 */